module.exports = __webpack_public_path__ + "CHEVROLET-logo.png";